var Component = require("!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./choose-new-plan.js"),
  /* template */
  require("!!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-05d19ffa!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./choose-new-plan.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/account/contract/choose-new-plan.vue
// module id = 522
// module chunks = 1